import React, { useState } from 'react';
import { Button } from '../../Button';
import { DialogFooter } from '../../Dialog';
import { Input } from '../../Input';
import { StatefulPanel } from '../../Panel';
import { Radio } from '../../Radio';
import { RadioGroup } from '../../Radio-group';
import { Tooltip } from '../../Tooltip';
import { StandardClauseItems, StandardClausesContentProps } from './types';
import { useStyletron } from '../../../Themes';

export const StandardClausesContent = ({
	handleClose,
	handleSave,
	standardCausesData,
}: StandardClausesContentProps) => {
	const [value, setValue] = useState(undefined);

	const [searchText, setSearchText] = useState<string>('');
	const [selected, setSelected] = useState<StandardClauseItems>();

	const [standardClauses, setStandardClauses] = useState(standardCausesData);
	const [css] = useStyletron();

	const handleSaveText = () => {
		handleSave(selected!.description);
	};

	const handleChangeSearchInput = (input: React.ChangeEvent<HTMLInputElement>) => {
		const subStr = input.target.value;

		setSearchText(input.target.value || '');

		if (!subStr.length) {
			setStandardClauses(standardCausesData);
			return;
		}

		const sc = standardCausesData.filter(item => {
			const values = item.clauses.filter(row => {
				return row.title.toLowerCase().includes(subStr);
			});
			return !!values.length;
		});

		setStandardClauses([...sc]);
	};

	const radioHandler = (e, index) => {
		const selectedClause = standardClauses[index].clauses.filter(clause => clause.id === e.target.value)[0];
		setSelected(selectedClause);
		setValue(e.target.value);
	};

	return (
		<div id="standard-clause-parent" data-testid="epods-standard-clauses-context" className="h-100">
			<div className="d-flex flex-column h-100">
				<div className="pb-m">
					<Input
						id="standard-clause-search-input"
						placeholder={'Search standard clauses'}
						onChange={handleChangeSearchInput}
						tabIndex={0}
						value={searchText}
						iconBefore="search"
					/>
				</div>
				<div
					className={
						'pb-l pt-xs px-xs ' +
						css({
							overflow: 'auto',
						})
					}
					id="accardionId"
					data-testid="epods-sc-accordion"
				>
					{standardClauses.map((item, index) => {
						return (
							<div key={index}>
								<StatefulPanel
									hideSeparator
									hideBorderRight
									hideBorderLeft
									hideBorderTop
									hideShadow
									hideHorizontalSpacing
									title={item.name}
								>
									<RadioGroup name="radio-g" value={value} onChange={e => radioHandler(e, index)}>
										{item.clauses.map((row, innerIndex) => {
											return (
												<Radio
													className="py-xs ml-xs"
													overrides={{
														Root: {
															style: {
																alignItems: 'flex-start',
																display: 'flex',
															},
														},
														Label: {
															style: {
																whiteSpace: 'normal',
															},
														},
														RadioMarkOuter: {
															style: {
																marginTop: '3px',
															},
														},
													}}
													key={row.id}
													value={row.id}
												>
													{row.title}
												</Radio>
											);
										})}
									</RadioGroup>
								</StatefulPanel>
							</div>
						);
					})}
				</div>
				<div
					style={{
						border: '1px solid var(--epods--color-bluegrey-500)',
						borderRadius: '4px',
						color: 'var(--epods--color-text-secondary)',
						padding: '5px 10px',
						overflowY: 'auto',
						minHeight: '60px',
						flexGrow: 1,
						fontFamily: 'var(--epods--font-secondary)',
					}}
				>
					{selected?.description}
				</div>
				<DialogFooter id="standard-clause-dialog">
					<div>
						<Button className="mr-s" onClick={handleClose} theme="secondary">
							{'Cancel'}
						</Button>
						<Button id="standard-clause-insertBtn" onClick={handleSaveText} disabled={!selected}>
							{'Insert'}
						</Button>
					</div>
				</DialogFooter>
			</div>
		</div>
	);
};
